import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * Icon
 */

const Icon = ({ icon, layout }) => {
  const layoutClass = layout || '';
  return <span className={`icon icon-${icon} ${layoutClass}`}></span>;
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  layout: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Icon;
